


























































import { Reporting } from '@/model/reporting.model';
import { StoreActions, StoreMutations } from '@/store';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class ReportingPage extends Vue {
  get reporting() {
    return this.$store.state.reporting;
  }

  get total(): number {
    return this.reporting.reduce(
      (acc: number, r: Reporting): number => acc + r.count,
      0,
    );
  }

  mounted() {
    this.$store.dispatch(StoreActions.GetReporting);
  }
}
